import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=1c9d596c&scoped=true"
import script from "./billDetails.vue?vue&type=script&lang=ts"
export * from "./billDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d596c",
  null
  
)

export default component.exports